import { CiboUiContext } from '@cibo/ui'
import { Divider, FormControlLabel, Stack, Switch, Typography } from '@mui/material'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoginDevices } from '../LoginDevices'

export const Preferences = ({ hideDevices }: { hideDevices?: boolean }) => {
  const { t } = useTranslation('@cibo/profile/Preferences')
  const { colorMode } = useContext(CiboUiContext)

  return (
    <Stack spacing={5} divider={<Divider />}>
      <Stack spacing={5}>
        <Stack>
          <Typography color="text.secondary">{t('other')}</Typography>

          <FormControlLabel
            onChange={() => colorMode.toggleColorMode()}
            checked={colorMode.currentMode === 'dark'}
            control={<Switch />}
            sx={{ paddingLeft: 1 }}
            label={`${t('darkMode')}`}
            data-testid='darkMode'
          />
        </Stack>
      </Stack>
      {!hideDevices && <LoginDevices />}
    </Stack>
  )
}
